// @flow
import React, { Component } from "react";
import classNames from "classnames";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import FormLabel from "@material-ui/core/FormLabel";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormHelperText from "@material-ui/core/FormHelperText";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import { withStyles } from "@material-ui/core/styles";
import { InputStyles } from "./SingleTextField";

const styles = theme => ({
  ...InputStyles(theme),
});

type SingleSelectPropsType = {
  classes: { [key: string]: string },
  menus: Array<{ [key: string]: string }>,
  isInvalid?: boolean,
  label: string,
  name: string,
  isRequired?: boolean,
  value: string,
  onChange: Function,
  isMultiple?: boolean,
  inputClass?: string,
  rootClass?: string
};

class SingleSelect extends Component<SingleSelectPropsType, *> {
  constructor(props: SingleSelectPropsType) {
    super(props);
  }

  render(): * {
    const classes = this.props.classes;
    const menus = this.props.menus && this.props.menus.map((menu: {[key: string]: string}, i: number) => {
      return (
        <MenuItem 
          key={"menu-" + i} 
          value={menu.value}
          style={{
            fontWeight:
              this.props.name.indexOf(menu.value) === -1
                ? 400
                : 500,
          }}
        >
          {menu.label}
        </MenuItem>
      );
    });
    return (
      <FormControl fullWidth={true}>
        {this.props.label !== "" &&
          <InputLabel
            htmlFor={this.props.name}
            required={this.props.isRequired}
            error={this.props.isInvalid}
            classes={{
              formControl: classes.textFieldFormLabel
            }}
          >
            {this.props.label}
          </InputLabel>
        }
        <Select
          value={this.props.value}
          error={this.props.isInvalid}
          onChange={this.props.onChange}
          input={
            <Input 
              name={this.props.name}
              id={this.props.name} 
              classes={{
                root: this.props.rootClass,
                underline: classes.textFieldUnderline,
                input: classes.textFieldInput + " " + (this.props.inputClass ? this.props.inputClass : ""),
                error: classes.textUnderlineError
              }}
            />
          }
          inputProps={{ required: this.props.isRequired }}
          multiple={this.props.isMultiple}
        >
          {menus}
        </Select>
      </FormControl>
    );
  }
}

export default withStyles(styles)(SingleSelect);  


// WEBPACK FOOTER //
// ./src/global/components/SingleSelect.js